import { render } from "./Memorization.vue?vue&type=template&id=2a485541&scoped=true"
import script from "./Memorization.vue?vue&type=script&lang=js"
export * from "./Memorization.vue?vue&type=script&lang=js"

import "./Memorization.vue?vue&type=style&index=0&id=2a485541&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a485541"]])

export default __exports__